'use client';

import { Button } from '@/components/ui/button/button';
import { Image } from '@/components/ui/image/image';
import { formatDateWithOrdinal } from '@/lib/contentful/utils';
import { cn } from '@/lib/utils';
import Link from 'next/link';
import { useRouter } from 'next/navigation';
import { useState } from 'react';
import { ListingItem } from './listing';
import styles from './listingItem.module.scss';

type ListingItemCardProps = {
  item: ListingItem;
};
export const ListingItemCard = ({ item }: ListingItemCardProps) => {
  const router = useRouter();
  const [loading, setLoading] = useState(false);

  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();
    setLoading(true);
    router.push(item.url);
  };

  return (
    <article className={styles.card}>
      <Link href={item.url} className={styles.link} onClick={handleClick}>
        {item.featuredImage?.url ? (
          <Image
            src={item.featuredImage.url as string}
            alt={item.featuredImage.title || item.title}
            width={800}
            height={450}
            sizes="(max-width: 768px) 100vw, 33vw"
            className={styles.featImg}
          />
        ) : (
          <div className={cn(styles.featImg, styles.featImgPlaceholder)} />
        )}

        <div className={styles.content}>
          <div className={styles.pills}>
            {(() => {
              const override = item.dateDisplayOverride?.trim();
              const dateFromField = item.eventsDate ? formatDateWithOrdinal(item.eventsDate) : null;
              const dateLabel =
                override && override.toLowerCase() !== 'updated' ? override : dateFromField;
              if (!dateLabel) return null;
              return (
                <span className={cn(styles.pill, styles.pillDate)}>
                  <Image src="/images/calendar.svg" alt="" width={13} height={14} />
                  {dateLabel}
                </span>
              );
            })()}
            {item.itemType && (
              <span className={cn(styles.pill, styles.pillType)}>{item.itemType}</span>
            )}
          </div>

          <h6>{item.title}</h6>
          <p>{item.address}</p>

          <span className={styles.ctaWrap}>
            <Button withArrow={!loading} className={styles.cta} tabIndex={-1}>
              <span className={cn(styles.ctaInner, loading && styles.ctaLoading)}>
                <span className={styles.ctaText}>Find out more</span>
                {loading && <span className={styles.spinner} />}
              </span>
            </Button>
          </span>
        </div>
      </Link>
    </article>
  );
};
